import { Fab } from '@mui/material'
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome'

import { getFontColor } from '../../../lib/colorUtils'
import usePrimaryColor from '../../../lib/hooks/usePrimaryColor'
import ASSISTANT_NAME from '../assistantName'
import { ASSISTANT_DRAWER_PAPER_ID } from '../AssistantDrawer'

const OPEN_LABEL = `Open ${ASSISTANT_NAME}`

interface AssistantFabProps {
  isOpen: boolean
  onClick: () => void
}

/**
 * Floating action button that opens the Civitas Learning AI panel.
 * Styled with the institution's primary color, matching other action buttons in the app.
 */
const AssistantFab = ({ isOpen, onClick }: AssistantFabProps) => {
  const color = usePrimaryColor()
  const fontColor = getFontColor(color)

  return (
    <Fab
      size="medium"
      aria-label={OPEN_LABEL}
      aria-expanded={isOpen}
      aria-controls={ASSISTANT_DRAWER_PAPER_ID}
      onClick={onClick}
      sx={{
        position: 'fixed',
        bottom: 24,
        right: 24,
        zIndex: 1050,
        backgroundColor: color,
        color: fontColor,
        '&:hover': { backgroundColor: color, filter: 'brightness(0.9)' }
      }}
    >
      <AutoAwesomeIcon />
    </Fab>
  )
}

export default AssistantFab
